// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .pcn-list {
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0px 0px 10px #ccc;
    background-color: #f8f8f8;
      height: 400px;
      overflow-y: scroll;
  }
  
  h1 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .search {
    margin-bottom: 20px;
  }
  
  .search input {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    box-shadow: 0px 0px 5px #ccc;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  thead {
    background-color: #f2f2f2;
  }
  
  th {
    text-align: left;
    padding: 10px;
  }
  
  td {
    text-align: left;
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
  
  td.error {
    color: red;
    font-weight: bold;
  }
  
  tr.success {
    background-color: #fff;
    color: green;
    font-weight: bold;
  }
  
  .pagination {
    list-style: none;
    display: flex;
    justify-content: center;
  }
  
  .pagination li {
    margin: 0 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .pagination li.active {
    background-color: #007bff;
    color: #fff;
    border-color: #007bff;
  }
  .copy-text{
    color: #525f7a;
    border: none;
    outline: inherit;
    display: flex;
    background: none;
    justify-content: center;
    align-items: center;
font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/PCNList/PCNList.css"],"names":[],"mappings":"EAAE;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;MACvB,aAAa;MACb,kBAAkB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB,eAAe;AACf","sourcesContent":["  .pcn-list {\n    margin: 20px;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0px 0px 10px #ccc;\n    background-color: #f8f8f8;\n      height: 400px;\n      overflow-y: scroll;\n  }\n  \n  h1 {\n    font-size: 28px;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  .search {\n    margin-bottom: 20px;\n  }\n  \n  .search input {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    border: none;\n    border-radius: 5px;\n    box-shadow: 0px 0px 5px #ccc;\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  thead {\n    background-color: #f2f2f2;\n  }\n  \n  th {\n    text-align: left;\n    padding: 10px;\n  }\n  \n  td {\n    text-align: left;\n    padding: 10px;\n    border-bottom: 1px solid #ccc;\n  }\n  \n  td.error {\n    color: red;\n    font-weight: bold;\n  }\n  \n  tr.success {\n    background-color: #fff;\n    color: green;\n    font-weight: bold;\n  }\n  \n  .pagination {\n    list-style: none;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .pagination li {\n    margin: 0 10px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .pagination li.active {\n    background-color: #007bff;\n    color: #fff;\n    border-color: #007bff;\n  }\n  .copy-text{\n    color: #525f7a;\n    border: none;\n    outline: inherit;\n    display: flex;\n    background: none;\n    justify-content: center;\n    align-items: center;\nfont-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
